import { HTMLDisplayComponentJSON } from "./../htmlComponent/HTML-Display-Component-JSON";

export class QuestionDetailsHeaderResponseJSON {
    surveyID: Number;
    userName: string;
    email: String;
    hHTMLDisplayComponentList: HTMLDisplayComponentJSON[];

    constructor(){
        this.hHTMLDisplayComponentList=new Array<HTMLDisplayComponentJSON>();
    }
}